module.exports = __webpack_public_path__ + "static/media/valuation_hero_house.3453fbb1.svg";